exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#modal-orders-sales-orders-show-customer-card .modal-content .default-card{width:1px}#modal-orders-sales-orders-show-customer-card .modal-content .highlight-green{background-color:green}", ""]);

// exports
